<div>
  <div>
    <div class="property-error">
      <div class="error-content">
        <div class="error-msg">
          <div>
            <p class="desc">{{ compData?.container?.description }}</p>
            <p class="question">
              What are you looking for? If there’s a specific hotel, homestay, resort, activity or day outing package
              missing from our app, simply let us know, and we’ll gladly add it for you!
            </p>
          </div>
        </div>
        <div class="error-btn">
          <button (click)="enquriyNow()" class="enquireBtn" tapEffect>Enquire Now!</button>
        </div>
      </div>
    </div>
  </div>
</div>
